import { ICianApiSiteV1GetRegionResponse } from 'shared/repositories/monolith-python/cian-api/site/v1/get-region';

export function dataFromGetRegionSelector(
  state: ICianApiSiteV1GetRegionResponse,
): ICianApiSiteV1GetRegionResponse['data'] {
  return state.data;
}
